import { Toggl } from '../../shared/utils/togglz';
import { useGlobalContext } from '../GlobalContextProvider';
import { TogglzActionType } from './togglzReducer';
import { useCallback } from 'react';

export const useTogglz = () => {
    const { state, dispatch } = useGlobalContext();

    return {
        togglz: state.togglz,
        setTogglz: useCallback(
            (togglz: ReadonlyArray<Toggl>) => {
                dispatch({ type: TogglzActionType.SET_TOGGLZ, payload: togglz });
            },
            [dispatch]
        )
    };
};
